import { gql, TypedDocumentNode } from "@apollo/client";

import { ScimOauthClient } from "types/generated";

type ScimOauthClientFields = Pick<
  ScimOauthClient,
  "clientID" | "clientSecret" | "accessTokenEndpoint" | "connnectorBaseURL"
>;

type CreateScimOauthClientData = { createOauthClientForSCIM: ScimOauthClientFields };
export const CREATE_SCIM_OAUTH_CLIENT: TypedDocumentNode<CreateScimOauthClientData> = gql`
  mutation CreateScimOauthClient {
    createOauthClientForSCIM {
      clientID
      clientSecret
      accessTokenEndpoint
      connnectorBaseURL
    }
  }
`;

type ResetScimOauthClientData = { resetOauthClientForSCIM: ScimOauthClientFields };
export const RESET_SCIM_OAUTH_CLIENT: TypedDocumentNode<ResetScimOauthClientData> = gql`
  mutation ResetScimOauthClient {
    resetOauthClientForSCIM {
      clientID
      clientSecret
      accessTokenEndpoint
      connnectorBaseURL
    }
  }
`;

type DeleteScimOauthClientData = { deleteOauthClientForSCIM: boolean };
export const DELETE_SCIM_OAUTH_CLIENT: TypedDocumentNode<DeleteScimOauthClientData> = gql`
  mutation DeleteScimOauthClient {
    deleteOauthClientForSCIM
  }
`;
